import {
  AutocompleteInput,
  ReferenceInput,
  TextInput,
} from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

const saleReturnFilterList = (permissions) => {
  const defaultFilter = [
    // <TextInput
    //   source="all"
    //   label="mine.filter.search_all"
    //   alwaysOn
    //   resettable
    //   variant="outlined"
    //   InputProps={{
    //     endAdornment: (
    //       <InputAdornment position="end">
    //         <SearchIcon />
    //       </InputAdornment>
    //     ),
    //   }}
    // />,
    <TextInput
      alwaysOn
      source="code"
      label="mine.label.receipt_no"
      resettable
      variant="outlined"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="start_date"
      label="mine.label.start_date"
      variant="outlined"
      maxDateSource="end_date"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="end_date"
      label="mine.label.end_date"
      variant="outlined"
      minDateSource="start_date"
    />,
    <ReferenceInput
      alwaysOn
      source="customer_id"
      reference="customers"
      sort={{ field: "customers.code", order: "ASC" }}
      perPage={10}
    >
      <AutocompleteInput
        optionText="name"
        resettable
        variant="outlined"
        label="mine.label.customer"
      />
    </ReferenceInput>,
    <AutocompleteInput
      alwaysOn
      source="type"
      optionText="name"
      resettable
      variant="outlined"
      label="mine.label.type"
      choices={[
        { id: 1, name: "mine.radio_btn.return_warehouse" },
        { id: 2, name: "mine.radio_btn.return_broken" },
      ]}
    />,
    <ReferenceInput alwaysOn source="quality_id" reference="qualities">
      <AutocompleteInput
        label="mine.label.quality"
        variant="outlined"
        fullWidth
        optionValue="id"
        optionText="name"
        filterToQuery={(searchText) => ({
          name: searchText,
        })}
      />
    </ReferenceInput>,
    <ReferenceInput alwaysOn source="size_id" reference="sizes">
      <AutocompleteInput
        label="mine.label.size"
        variant="outlined"
        fullWidth
        optionValue="id"
        optionText="name"
        filterToQuery={(searchText) => ({
          name: searchText,
        })}
      />
    </ReferenceInput>,
    <TextInput
      alwaysOn
      source="note"
      label="mine.label.note"
      resettable
      variant="outlined"
    />,
  ];
  if (permissions && permissions.update_company) {
    defaultFilter.splice(
      1,
      0,
      <ReferenceInput
        alwaysOn
        source="company_id"
        reference="companies"
        sort={{ field: "companies.alias", order: "ASC" }}
      >
        <AutocompleteInput
          resettable
          optionText="alias"
          variant="outlined"
          label="mine.label.company"
        />
      </ReferenceInput>
    );
  }
  return defaultFilter;
};
export default saleReturnFilterList;
